import { useState } from 'react'
import { SmartForm } from '../../components/formFields/Form'
import { TextField } from '../../components/formFields/TextField'
import { AxiosError } from 'axios'
import toast from 'react-hot-toast'
import { api } from '../../data/api'
import { Spinner } from '../../components/spinner/Spinner.component'
import { useNavigate, useParams } from 'react-router-dom'
import { PasswordField } from '../../components/formFields/password/Password.component'
import { copyJson } from '../../helpers/general.helper'

export const ForgotPassPage = () => {
	const navigate = useNavigate()
	const [dni, setDni] = useState('')
	const [loading, setLoading] = useState(false)
	const [errors, setErrors] = useState<Record<string, string | undefined>>({})

	const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault()

		if (dni.length < 8) setErrors({...errors, dni: 'El DNI debe tener 8 dígitos'})
			
		setLoading(true)
		try {
			await api.get(`/api/authm/forgotpass/${dni}`)
			navigate(`/med/forgot-pass/validate/${dni}`)
		} catch (error) {
			console.error("### error", error)
			toast.error(error instanceof AxiosError ? error.response?.data?.message :'Error recuperando la contraseña')
		} finally {
			setLoading(false)
		}
	}

	if (loading) return <Spinner />

	return (
		<SmartForm
			title="Recuperar Contraseña"
			onSubmit={handleSubmit}
			confirmButtonLabel="Recuperar"
		>
			<TextField
				label="DNI"
				value={dni}
				maxLength={10}
				onChange={(value) => {
					setDni(value)
					if (errors.dni) setErrors({...errors, dni: undefined})
				}}
				error={errors.dni}
			/>
		</SmartForm>
	)
}

export const ForgotPassValidatePage = () => {
	const params = useParams()
	const dni = params.dni as string
	const [formData, setFormData] = useState<{
		dni: string,
		code: string,
		password: string,
		confirm: string,
	}>({
		dni,
		code: '',
		password: '',
		confirm: '',
	})

	const [loading, setLoading] = useState(false)
	const [errors, setErrors] = useState<Record<string, string | undefined>>({})
	const [failed, setFailed] = useState(false)
	const navigate = useNavigate()

	const validateForm = () => {
		const newErrors = errors === undefined ? {} : copyJson(errors)
		if (!formData.password) newErrors.password = 'La contraseña es obligatoria'
		if (!formData.confirm) newErrors.confirm = 'La confirmación de contraseña es obligatoria'
		if (!formData.code) newErrors.code = 'El código es obligatorio'
		if (!formData.password?.length || formData.password.length < 8 || formData.password.length > 12) newErrors.password = 'La contraseña debe tener entre 8 y 12 characteres'
		if (!formData.confirm?.length || formData.confirm.length < 8 || formData.confirm.length > 12) newErrors.confirm = 'La confirmación de contraseña debe tener entre 8 y 12 characteres'
		if (!formData.code?.length || formData.code.length <4) newErrors.code = 'El código debe tener al menos4 dígitos'
		if (formData.password !== formData.confirm) newErrors.confirm = 'Las contraseas no coinciden'
		setErrors(newErrors)
		return Object.keys(newErrors).length === 0
	}

	const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault()

		if (failed) {
			navigate('/med/login')
			return
		}

		if (!validateForm()) return

		setLoading(true)
		try {
			await api.post('/api/authm/forgotpass', {
				dni: formData.dni,
				code: formData.code,
				password: formData.password,
			})
			toast.success('Contraseña cambiada correctamente')
			navigate('/med/login')
		} catch (error: any) {
			console.error("### error", error)
			if (error.status === 401) {
				setFailed(true)
			} else {
				toast.error(error instanceof AxiosError ? error.response?.data?.message :'Error recuperando la contraseña')
			}
		} finally {
			setLoading(false)
		}
	}

	if (loading) return <Spinner />

	return (
		<SmartForm
			title="Recuperar Contraseña"
			onSubmit={handleSubmit}
			confirmButtonLabel={failed ? 'Volver' : 'Recuperar'}
		>
			{failed && <p>El código ingresado es incorrecto. La password no ha sido cambiada. Si realmente tiene acceso a la cuenta, puede solicitar un nuevo código repitiendo el proceso de recuperación de contraseña.</p>}
			{!failed && 
			<>
				<TextField
					label="Código"
					value={formData.code}
					onChange={(value) => {
						setFormData({...formData, code: value})
						if (errors.code) setErrors({...errors, code: undefined})
					}}
					error={errors.code}
				/>
				<PasswordField
					label="Contraseña"
					value={formData.password}
					onChange={(value) => {
						setFormData({...formData, password: value})
						if (errors.password) setErrors({...errors, password: undefined})
					}}
					error={errors.password}
				/>
				<PasswordField
					label="Confirmar Contraseña"
					value={formData.confirm}
					onChange={(value) => {
						setFormData({...formData, confirm: value})
						if (errors.confirm) setErrors({...errors, confirm: undefined})
					}}
					error={errors.confirm}
				/>
			</>
		}
		</SmartForm>
	)
}